module.exports = __webpack_public_path__ + "img/appart-sejour (2).faeb338a.jpg";